import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Unstable_Grid2 as Grid } from '@mui/material';
import { isEmpty } from 'lodash';

import { GroupPicker } from 'components/Pickers';
import { RemoveIcon } from 'components';
import { GroupFragment, SearchPostsFilter, UserFeedFollowGroupFragment } from 'api';
import { useSearchFilter } from 'providers';

interface Props {
  filters: SearchPostsFilter;
  setFilters: (filters: SearchPostsFilter) => void;
}

const Group: FC<Props> = ({ filters, setFilters }) => {
  const { t } = useTranslation();
  const { selectedGroups, setSelectedGroups } = useSearchFilter();

  const groupList = selectedGroups.filter(group => filters.group_list?.includes(group.id));
  const [activeGroups, setActiveGroups] = useState<UserFeedFollowGroupFragment[]>(groupList);

  useEffect(() => {
    if (isEmpty(filters.group_list)) {
      setActiveGroups([]);
      setSelectedGroups([]);
    }
  }, [filters.group_list]);

  function onChangeGroupPicker(groups: GroupFragment[]) {
    setActiveGroups(groups);
    setSelectedGroups(groups);

    const groupIds = groups.map(group => group.id);
    setFilters({ ...filters, group_list: groupIds });
  }

  function onClickDeleteIcon() {
    setActiveGroups([]);
    setSelectedGroups([]);
    setFilters({ ...filters, group_list: [] });
  }

  return (
    <Grid container alignItems="center">
      <Grid xs={3}>
        <Typography variant="body2">{t('common:group')}</Typography>
      </Grid>

      <Grid xs={8}>
        <GroupPicker
          selectedGroups={activeGroups}
          onSelectedGroupsChange={onChangeGroupPicker}
          scope={'followed'}
          fullWidth
        />
      </Grid>

      {!!filters.group_list.length && (
        <Grid xs={1} container justifyContent="center">
          <RemoveIcon onClick={onClickDeleteIcon} lighter />
        </Grid>
      )}
    </Grid>
  );
};

export default Group;
